import { MutationTree } from 'vuex';
import { State }        from 'src/views/settings/store/settings.state.store';

const mutations: MutationTree<State> = {
  setRateChecker(state): void {
    const hasRateChecker = state.settingsList.find((element) => element.name === 'rateChecker');
    if (!hasRateChecker) {
      state.settingsList.push(
        {
          name: 'rateChecker',
          links: [
            {
              name: 'rateCheckerSettings',
              path: '/settings/rate-checker',
            },
            {
              name: 'rateCheckerTable',
              path: '/settings/rate-checker/table',
            },
          ],
        },
      );
    }
  },
};

export default mutations;
